export default __webpack_public_path__ + "static/media/medical-2.76ab23e5.jpg";